import { getCountryByCode } from "../../../../service/CountryService"
import { useQuery } from "react-query"

function useGetCountries(tunnelData, countryCodeFromLanguage, languageTag) {
  return useQuery({
    queryKey: ["query-countries", languageTag],
    queryFn: () =>
      getCountryByCode(tunnelData, {
        countryCode: countryCodeFromLanguage,
        languageTag
      }),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    retry: 3,
    retryDelay: 5000,
    enabled: true
  })
}

export default useGetCountries
